import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AportacionDisddrcaControllerService } from './api/aportacionDisddrcaController.service';
import { FacturaSddrcaControllerService } from './api/facturaSddrcaController.service';
import { HelloWorldControllerService } from './api/helloWorldController.service';
import { SolicitudEnvaseControllerService } from './api/solicitudEnvaseController.service';
import { SolicitudEnvaseEstadoControllerService } from './api/solicitudEnvaseEstadoController.service';
import { SolicitudFacturaExportacionControllerService } from './api/solicitudFacturaExportacionController.service';
import { SolicitudInformeRetiradaControllerService } from './api/solicitudInformeRetiradaController.service';
import { SolicitudInformeRetiradaDocumControllerService } from './api/solicitudInformeRetiradaDocumController.service';
import { SolicitudRetiradaControllerService } from './api/solicitudRetiradaController.service';
import { SolicitudRetiradaEstadoControllerService } from './api/solicitudRetiradaEstadoController.service';
import { SolicitudReutilizacionAcreditacionControllerService } from './api/solicitudReutilizacionAcreditacionController.service';
import { SolicitudReutilizacionControllerService } from './api/solicitudReutilizacionController.service';
import { SolicitudReutilizacionEstadoControllerService } from './api/solicitudReutilizacionEstadoController.service';
import { SubTipoEnvaseControllerService } from './api/subTipoEnvaseController.service';
import { TarifaGestorSddrcaControllerService } from './api/tarifaGestorSddrcaController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AportacionDisddrcaControllerService,
    FacturaSddrcaControllerService,
    HelloWorldControllerService,
    SolicitudEnvaseControllerService,
    SolicitudEnvaseEstadoControllerService,
    SolicitudFacturaExportacionControllerService,
    SolicitudInformeRetiradaControllerService,
    SolicitudInformeRetiradaDocumControllerService,
    SolicitudRetiradaControllerService,
    SolicitudRetiradaEstadoControllerService,
    SolicitudReutilizacionAcreditacionControllerService,
    SolicitudReutilizacionControllerService,
    SolicitudReutilizacionEstadoControllerService,
    SubTipoEnvaseControllerService,
    TarifaGestorSddrcaControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
